var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "omni-sidebar omni-sidebar-root"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('OmniSidebarItem', {
      key: index,
      attrs: {
        "item": item
      }
    });
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }